<!-- 애니매이션 My애니 선택용 팝업 -->
<template>
<v-row>

    <v-dialog persistent scrollable overlay-color="#00000040" 
        v-model="dialog_mycom" fullscreen="true" 
        >
        <v-card class="dialog_round pa-2">

            <v-card-text>
                <v-container fluid>

        <v-row dense>

            <v-col cols="5" >
                <v-row dense align="center" class="pa-0">
                    <v-col cols="12" align="center">
                        <label>My 애니매이션</label>
                    </v-col>
                </v-row>
                <v-row>
                    <!-- 테이블 -->
                    <v-data-table
                        class="datatablestyle"
                        :headers="headers_com"
                        :items="itemList_com"
                        style="min-height:400px"
                        no-data-text="데이터가 없습니다."
                        hide-default-footer
                        :items-per-page="pagerow_com"
                        item-key="IDX"
                        height="100%"
                        :mobile="false"
                        >
                        <template v-slot:header.MYANI_NAME>
                            <a :class="sort_name=='MYANI_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('MYANI_NAME')">애니</a>
                        </template>
                        <template v-slot:item.MYANI_NAME="{ item }">  
                            <a style="cursor:pointer;color:blue" @click="select_func(item)">{{ item.MYANI_NAME }}</a>
                        </template>     
                        <template v-slot:item.SHOWANI="{ item }">
                            <AniComponent 
                                style="cursor:pointer;" 
                                :anidata="item" @click="aniplay(item)"
                                />
                        </template>
                        <template v-slot:item.play="{ item }">  
                            <v-icon small @click="aniplay(item)">mdi-play</v-icon>
                        </template>     
                        <template v-slot:item.delete="{ item }">  
                            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
                        </template>     
                        <template v-slot:bottom></template>
                    </v-data-table>
                </v-row>

                <!-- 하단검색 -->
                <searchbar ref="searchbar_com" @searchcallback="search_run_com"/>

                <!-- 하단페이징영역 -->
                <pagingbar ref="paging_com" :page="page_com" @loadpage="movepage_com"/>
                
            </v-col>

            <v-col cols="7">
                <div id="edit_div" class="viewport" style="border: 1px red solid; width:100%;height:100%; overflow:hidden;background: linear-gradient(to bottom, #2c3e50, #1a1a1a);"/>
            </v-col>

        </v-row>
  
        </v-container>
        </v-card-text>

        <v-card-actions>
            <v-row justify="center">
                <v-btn class="dialog_cancel_btn" rounded large @click="close_com">닫기</v-btn>
            </v-row>
        </v-card-actions>
    </v-card>
    </v-dialog>     
</v-row>
</template>

<script>
import AniComponent from '@/nextvue/preview/AniComponent.vue'
import gsap from "gsap";
import Component_Model from '@/nextts/model/Component_Model'
import EditBasic_Element from '@/nextts/edit/EditBasic_Element'
import { ref, reactive } from '@vue/reactivity';
import wait from 'waait';
import AnimationPlay_Model from '@/nextts/model/AnimationPlay_Model';
export default {
        
    //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
    props:{
        comname: String,
    },

    components:{
        // eslint-disable-next-line vue/no-unused-components
        AniComponent
    },
    
    watch:{
        dialog_mycom: async function(v1){
            //console.log("v1 : " + v1 + " / v2 : " + v2);
            if(v1){
                //팝업이 뜬 경우
                await wait(250);
                this.page_com = 1;
                
                const edit_div = document.getElementById("edit_div");
                let tempcm    = new Component_Model();
                tempcm.width  = 100;
                tempcm.height = 100;
                tempcm.component_type = Component_Model.COMPONENT_ANITEST;
                tempcm.posx   = 0;
                tempcm.posy   = 0;
                tempcm.rotate = 0;
                tempcm.transx = 250;
                tempcm.transy = 200;
                this.anielement = new EditBasic_Element(reactive(tempcm));
                edit_div.appendChild(this.anielement);

                this.loadpage_com(1);
            }
        },
    },
    

    setup(){
        
        const searchbar_com = ref(null);
        const paging_com    = ref(null);
        return {searchbar_com, paging_com};
    },

    data: ()=> ({

        anielement:null,

        dialog_mycom : false,
        load_flag : false,
        sort_name_com: 'REG_DATE',
        sort_type_com: true,    //true : DESC, false: ASC
        
        //테이블 정의
        headers_com: [
            {title: '애니', key: 'MYANI_NAME', sortable: false, align:'center', class:"cheader_normal"},
            {title: '미리보기', key: 'SHOWANI', width:150, sortable: false, align:'center', class:"cheader_normal"},
            {title: '재생', key: 'play', width:80, sortable: false, align:'center', class:"cheader_normal"},
            {title: '삭제', key: 'delete', width:80, sortable: false, align:'center', class:"cheader_normal"}
        ],

        page_com : 0,
        pagerow_com: 20,
        maxpage_com : 0,       //전체 페이지 개수
        itemList_com: [],
        search_keyword_com : '',
    }),

    mounted(){
        
    },


    methods: {


        //전체 플레이
        aniplay(item){

            const aniplay = new AnimationPlay_Model();
            aniplay.setStringValue(item.ANI_JSON);

            if(aniplay == null || aniplay == undefined || aniplay.anilist.length < 1){
                
                return;
            }

            let timeline = gsap.timeline({repeat:Number(aniplay.repeat), repeatDelay:Number(aniplay.repeatDelay), yoyo:Boolean(aniplay.yoyo)});
            //let from = {x:this.anielement.model.transx, y:this.anielement.model.transy, rotate:this.anielement.model.rotate, alpha:this.anielement.model.alpha, scale:1}
            //timeline.from(from);

            //애니의 좌표를 += 되는 개념이다. 나머지는 그냥 바로 해당 수치로 변경되면 된다.
            let move_posx   = Number(this.anielement.model.transx);
            let move_posy   = Number(this.anielement.model.transy);
            let move_rotate = Number(this.anielement.model.rotate);
            
            let move_rotatex = 0;
            let move_rotatey = 0;
            let move_skewx   = 0;
            let move_skewy   = 0;

            //초기위치 - 이건 애니매이션을 한 화면에서 여러번 재생하니깐 해주는거다. 실제 뷰어에서는 필요 없다.
            timeline.to(this.anielement, { duration:0, x:move_posx, y:move_posy
                , scaleX:this.anielement.model.scalex, scaleY:this.anielement.model.scaley
                , rotationX:move_rotatex, rotationY:move_rotatey, rotation:move_rotate
                , skewX:move_skewx, skewY:move_skewy        
                , alpha:this.anielement.model.alpha });
            
            // eslint-disable-next-line no-unused-vars
            aniplay.anilist.forEach((ani, index)=>{
                move_posx += Number(ani.movex);
                move_posy += Number(ani.movey);
                move_rotate += Number(ani.rotate);
                move_rotatex += Number(ani.rotatex);
                move_rotatey += Number(ani.rotatey);
                move_skewx += Number(ani.skewx);
                move_skewy += Number(ani.skewy);

                //첫번째 인덱스의 딜레이는 항상 0으로 처리해야한다.
                const aniprop = { delay: ani.delay, duration:ani.duration, x:move_posx, y:move_posy
                                , scaleX:ani.scalex, scaleY:ani.scaley
                                , rotationX:move_rotatex, rotationY:move_rotatey, rotation:move_rotate
                                , skewX:move_skewx, skewY:move_skewy        
                                , alpha:ani.alpha, ease:`${ani.ease}.${ani.easetype}` 
                                , transformOrigin: `${ani.centerx}% ${ani.centery}%`};
                ani.proplist.forEach(prop=>{
                    aniprop[prop.propname] = prop.propvalue;
                });
                timeline.to(this.anielement, aniprop);
            });
            

        },

        update_dialog(){

            

        },
        
        searchbar_run(){
            
            this.$emit('searchcallback', this.search_keyword);
        },

        movepage_com(p){
            this.loadpage_com(p);
        },

        

      //검색
      search_run_com(searchkeyword){
        if(searchkeyword != null && searchkeyword != undefined && searchkeyword.length > 0){
          this.search_keyword_com = searchkeyword;
        }else{
          this.search_keyword_com = '';
        }
        this.loadpage_com(1);
      },      

        showpopup_com(){
            this.dialog_mycom = true;
            this.load_flag = false;
        },

        //다이얼로그 닫기
        close_com () {
            this.dialog_mycom = false
            this.select_com = [];
            this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            this.search_keyword_com = '';
        },

        //선택취소
        clear_com(){
            this.$emit('cancelcallback', '')
            this.dialog_mycom = false
            this.select_com = [];
            this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            this.search_keyword_com = '';
        },

        //선택
        select_func(select_item) {
            this.$emit('callback', select_item);
            //콜백 호출 후 닫아야함.
            this.dialog_mycom = false
            this.select_com = [];
            this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            this.search_keyword_com = '';
        },              


        delete_item(item){
            
            this.$swal({showCancelButton: true, title:'정말 삭제하시겠습니까?', customClass:{container:'frontswal'}})
            .then(async (aresult) => {
            if(aresult.isConfirmed){
                //토큰값 체크
                let token;
                try{
                token = await this.$fireauth.currentUser.getIdToken();
                }catch(error){
                token = this.$userStore.fireToken;
                }

                const SEARCH_LOCALID    = this.$userStore.searchLocalId;
                this.$http.post(this.$api_home+'/MyAnimationDelete',{
                       MYANI_IDX:item.MYANI_IDX
                    ,  LOCALID:SEARCH_LOCALID
                },{headers: { firetoken:token}})
                .then((result)=>{
                if(result.data.resultCode == 0){
                    this.$swal('삭제가 완료되었습니다.').then(()=>{
                        this.loadpage_com(1);
                    });
                    
                }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$swal("토큰 만료로 인해 다시 로그인해주세요.");
                    this.$emitter.emit('clearsession');
                    
                }else{
                    this.$swal('삭제가 실패했습니다.');
                }
                
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error)=>{
                    this.$swal('삭제 실패');
                });      
            }
            });


        },

        async loadpage_com(p){

            //토큰값 체크
            let token;
            try{
            token = await this.$fireauth.currentUser.getIdToken();
            }catch(error){
            token = this.$userStore.fireToken;
            }

            const SEARCH_LOCALID    = this.$userStore.searchLocalId;
            this.page_com = p;
            this.paging_com.setpage(this.page_com);
            this.$http.post(this.$api_home+'/MyAniList',{
                  search_keyword: this.search_keyword_com == null || this.search_keyword_com == undefined ?  '' : this.search_keyword_com
                , sort_name:this.sort_name_com
                , sort_type: this.sort_type_com == true ? "DESC" : "ASC" 
                , page: this.page_com
                , LOCALID:SEARCH_LOCALID
                , pagerow: this.pagerow_com
            },{headers: { firetoken:token}})
            .then((result)=>{
                
                if(result.data.resultCode == 0){

                    this.totalcnt_com = result.data.totalcnt;
                    this.paging_com.makepaging(this.totalcnt_com, this.pagerow_com);
                    const list = result.data.resultData;
                    this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                    list.forEach(element => {
                        this.itemList_com.push(element); 
                    });

                }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$swal("토큰 만료로 인해 다시 로그인해주세요.");
                    this.$emitter.emit('clearsession');
                }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
                
            });

        },        


    }

}
</script>

<style scoped>
.frontswal{
  z-index: 9999 !important;
}


.checkerboard {
    background-image: repeating-linear-gradient(45deg, #444, #444 10px, #888 0, #888 20px);
}

</style>